// Generated by scripts/split-locales.mjs. Do not edit by hand.
// Each page -> the namespaces its static import graph declares.
// Namespaces needed by shared chrome are in the inlined core, so they are
// deliberately absent here: loading them again would be a wasted request.
export const ROUTE_NAMESPACES: Record<string, readonly string[]> = {
  "AdminPanel": [
    "admin",
    "common"
  ],
  "ApplicationsBots": [
    "misc_ui",
    "common",
    "cookies",
    "footer",
    "nav",
    "contact_extra"
  ],
  "Audit": [
    "audit",
    "checkout",
    "meta",
    "audit_page",
    "audit_results",
    "audit_extra",
    "common",
    "misc_ui",
    "cookies",
    "footer",
    "nav",
    "contact_extra",
    "contact_modal"
  ],
  "Blog": [
    "meta",
    "blog",
    "dashboard",
    "common",
    "misc_ui",
    "cookies",
    "footer",
    "nav",
    "contact_extra"
  ],
  "BlogPost": [
    "blog",
    "dashboard",
    "common",
    "misc_ui",
    "cookies",
    "footer",
    "nav",
    "contact_extra"
  ],
  "ClientDashboard": [
    "dashboard",
    "misc_ui",
    "dash_extra",
    "tickets",
    "checkout",
    "hosting",
    "tracker",
    "contact_extra",
    "contact_modal",
    "common"
  ],
  "CompetitorGap": [
    "misc_ui",
    "competitor_gap",
    "common",
    "cookies",
    "footer",
    "nav",
    "contact_extra"
  ],
  "Contact": [
    "contact_extra",
    "contact_page",
    "contact_modal",
    "misc_ui",
    "common",
    "cookies",
    "footer",
    "nav"
  ],
  "ForgotPassword": [
    "misc_ui"
  ],
  "Home": [
    "checkout",
    "misc_ui",
    "login",
    "home_modern",
    "contact_extra",
    "common",
    "cookies",
    "footer",
    "nav"
  ],
  "KeywordExplorer": [
    "misc_ui",
    "keyword_explorer",
    "competitor_gap",
    "common",
    "nav",
    "cookies",
    "footer",
    "contact_extra"
  ],
  "LegalMentions": [
    "legal",
    "meta",
    "misc_ui",
    "common",
    "cookies",
    "footer",
    "nav",
    "contact_extra"
  ],
  "LocalService": [
    "misc_ui",
    "common",
    "cookies",
    "footer",
    "nav",
    "contact_extra"
  ],
  "Login": [
    "login",
    "misc_ui",
    "common"
  ],
  "NotFound": [
    "not_found",
    "nav"
  ],
  "PrivacyPolicy": [
    "legal",
    "meta",
    "misc_ui",
    "common",
    "cookies",
    "footer",
    "nav",
    "contact_extra"
  ],
  "ProductDetail": [
    "ui_components",
    "misc_ui",
    "common",
    "cookies",
    "footer",
    "nav",
    "contact_extra"
  ],
  "ResetPassword": [
    "misc_ui"
  ],
  "TermsOfService": [
    "legal",
    "meta",
    "misc_ui",
    "common",
    "cookies",
    "footer",
    "nav",
    "contact_extra"
  ],
  "UIComponents": [
    "ui_components",
    "nav",
    "misc_ui",
    "common",
    "cookies",
    "footer",
    "contact_extra"
  ]
} as const;

/**
 * Namespaces that are only PARTIALLY in the core: the eager graph uses a few
 * keys, but lazy home sections need the rest (`home_modern.hero` paints
 * immediately, `home_modern.services` does not). These are fetched right
 * after boot without blocking anything, so a scroll never waits on them.
 */
export const PARTIAL_NAMESPACES: readonly string[] = ["misc_ui","login","home_modern"] as const;

/**
 * Namespaces needed by components behind `React.lazy`, declared next to the
 * component that uses them. These are invisible to a page-level import graph,
 * so tests/i18nSplit.test.ts checks them against actual `t(...)` usage.
 */
export const LAZY_COMPONENT_NAMESPACES: Record<string, readonly string[]> = {
  "src/App.tsx": [
    "chat"
  ],
  "src/pages/Home.tsx": [
    "home_modern",
    "boost",
    "pricing",
    "cyber_rocket"
  ]
} as const;
